(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBestSellers(root) {
      if (!root || root.__bsInit) return;
      root.__bsInit = true;

      // Force navigation pour tous les liens de la section (bypass Fabric quick-add)
      root.addEventListener('click', function (e) {
        const link = e.target.closest('[data-bs-link]');
        if (!link || !root.contains(link)) return;
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1) return;
        const href = link.getAttribute('href');
        if (!href || href === '#') return;
        e.stopImmediatePropagation();
        e.preventDefault();
        window.location.assign(href);
      }, true);

      // Tabs
      const tabs = root.querySelectorAll('[data-bs-tab]');
      const panels = root.querySelectorAll('[data-bs-panel]');

      function activateTab(tab) {
        tabs.forEach((t) => {
          const active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          t.setAttribute('tabindex', active ? '0' : '-1');
        });
        panels.forEach((p) => {
          const shouldShow = p.id === tab.getAttribute('aria-controls');
          if (shouldShow) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
        const visiblePanel = root.querySelector('[data-bs-panel]:not([hidden])');
        if (visiblePanel) {
          const carousel = visiblePanel.querySelector('[data-bs-carousel]');
          if (carousel) updateArrows(carousel);
        }
      }

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activateTab(tab));
        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          const arr = Array.from(tabs);
          const i = arr.indexOf(tab);
          const next = e.key === 'ArrowRight' ? arr[(i + 1) % arr.length] : arr[(i - 1 + arr.length) % arr.length];
          next.focus();
          activateTab(next);
        });
      });

      // Carousels
      function updateArrows(carousel) {
        const track = carousel.querySelector('[data-bs-track]');
        const prev = carousel.querySelector('[data-bs-prev]');
        const next = carousel.querySelector('[data-bs-next]');
        if (!track || !prev || !next) return;
        const maxScroll = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll - 2;
      }

      function stepSize(track) {
        const firstCard = track.querySelector('.bs-card');
        if (!firstCard) return track.clientWidth;
        const style = getComputedStyle(track);
        const gap = parseFloat(style.columnGap || style.gap) || 0;
        return firstCard.getBoundingClientRect().width + gap;
      }

      // Centre verticalement les flèches sur l'IMAGE (pas sur toute la carte)
      function positionArrows(carousel) {
        const media = carousel.querySelector('.bs-card__media');
        const arrows = carousel.querySelectorAll('.bs-arrow');
        if (!media || !arrows.length) return;
        const mediaBox = media.getBoundingClientRect();
        // Si l'élément est masqué (panel hidden), offsetParent sera null et on ignore
        if (mediaBox.height === 0) return;
        const carouselBox = carousel.getBoundingClientRect();
        const centerY = (mediaBox.top - carouselBox.top) + (mediaBox.height / 2);
        arrows.forEach((a) => { a.style.top = centerY + 'px'; });
      }

      root.querySelectorAll('[data-bs-carousel]').forEach((carousel) => {
        const track = carousel.querySelector('[data-bs-track]');
        const prev = carousel.querySelector('[data-bs-prev]');
        const next = carousel.querySelector('[data-bs-next]');
        if (!track) return;

        prev && prev.addEventListener('click', () => {
          const s = stepSize(track);
          const perPage = Math.max(1, Math.floor(track.clientWidth / s));
          track.scrollBy({ left: -s * perPage, behavior: 'smooth' });
        });
        next && next.addEventListener('click', () => {
          const s = stepSize(track);
          const perPage = Math.max(1, Math.floor(track.clientWidth / s));
          track.scrollBy({ left: s * perPage, behavior: 'smooth' });
        });
        track.addEventListener('scroll', () => updateArrows(carousel), { passive: true });
        window.addEventListener('resize', () => {
          updateArrows(carousel);
          positionArrows(carousel);
        });

        // Position initiale + re-position après chaque chargement d'image
        updateArrows(carousel);
        positionArrows(carousel);
        carousel.querySelectorAll('img').forEach((img) => {
          if (img.complete) return;
          img.addEventListener('load', () => positionArrows(carousel), { once: true });
        });
      });

      // Re-positionner quand on change d'onglet (les panels hidden n'ont pas de layout)
      root.addEventListener('click', (e) => {
        if (!e.target.closest('[data-bs-tab]')) return;
        requestAnimationFrame(() => {
          root.querySelectorAll('[data-bs-panel]:not([hidden]) [data-bs-carousel]').forEach(positionArrows);
        });
      });
    }

    document.querySelectorAll('.best-sellers').forEach(initBestSellers);
    document.addEventListener('shopify:section:load', (e) => {
      const section = e.target.querySelector('.best-sellers');
      if (section) initBestSellers(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
